<template>
  <div class="borFrame">
    <ul class="list">
      <li>
        <span>信息量：{{ allTotalNumber }}</span>
      </li>
      <li>
        <span>属性：</span>
        <van-dropdown-menu>
          <van-dropdown-item v-model="form.attribute" :options="option1" @change="getListChange" />
        </van-dropdown-menu>
      </li>
    </ul>
    <ul class="list">
      <li>
        <span>排序：</span>
        <van-dropdown-menu>
          <van-dropdown-item v-model="form.sort" :options="option2" @change="getListChange" />
        </van-dropdown-menu>
      </li>
      <li>
        <span>来源：</span>
        <van-dropdown-menu>
          <van-dropdown-item v-model="form.source" :options="option3" @change="getListChange" />
        </van-dropdown-menu>
      </li>
    </ul>
    <ul class="list">
      <li>
        <span>时间：</span>
        <!-- <van-cell :value="form.date" @click="show = true" /> -->
        <span @click="show = true" style="display: inline-block; width:50%;"
          :style="{ color: form.date ? '#333' : '#ccc' }">{{ form.date ? form.data : '请选择时间' }}</span>
      </li>
      <li>
        <van-search show-action v-model="form.search" placeholder="搜索关键词">
          <template #action>
            <div @click="getListChange">搜索</div>
          </template>
        </van-search>
      </li>
    </ul>
    <van-calendar v-model="show" type="range" :min-date="minDate" :max-date="maxDate" @confirm="onConfirm" />
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList">
      <div class="borFrame_content" v-for="(item, index) in list" :key="index">
        <div class="borFrame_content_box">
          <van-tag :color="'#eb6863'" class="borFrame_content_box_tag">{{ item.characteristic ? item.characteristic : '无害'
          }}</van-tag> <span class="borFrame_content_box_title">{{ item.title }}
          </span>
        </div>
        <p class="borFrame_content_more" v-html="item.content" @click="detail(item)">
        </p>
        <div class="borFrame_content_btm">
          <van-tag class="borFrame_content_box_tag" v-for="(item, index) in item.keywords" :key="index">{{
            item }}</van-tag>
        </div>
        <div class="borFrame_content_sub">
          <div class="borFrame_content_sub_icon">
            <van-image class="img" round width="0.3rem" height="0.3rem" :src="item.userProfileImgUrl" />
            <span>来自：{{ item.source }}{{ item.userName ? '·' + item.userName : '' }}</span>
          </div>
          <div class="borFrame_content_sub_time">
            {{ moment(item.issueTime).format('YYYY-MM-DD HH:mm:ss') }}</div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { warningPage, getSource } from '@/api/index'
import moment from 'moment';
export default {
  data() {
    return {
      show: false,
      minDate: new Date(2000, 0, 1),  // 设置最小日期
      maxDate: new Date(2100, 11, 31), // 设置最大日期
      form: {
        attribute: '全部',
        sort: 'desc',
        source: '全部',
        date: '',
        search: ''
      },
      time: [],
      page: {
        pageNum: 1,
        pageSize: 10,
      },
      value1: 0,
      option1: [
        { text: '全部', value: '全部' },
        { text: '中性', value: '中性' },
        { text: '疑似有害', value: '疑似有害' },
        { text: '无害言论', value: '无害言论' },
        { text: '正面', value: '正面' },
        { text: '有害言论', value: '有害言论' },
      ],
      option2: [
        { text: '升序', value: 'asc' },
        { text: '降序', value: 'desc' },
      ],
      option3: [
        { text: '全部', value: '全部' },
      ],
      list: [],
      loading: false,
      finished: false,
      allTotalNumber: 0
    }
  },
  created() {
    this.form.attribute = this.$route.query.characteristic ? this.$route.query.characteristic : '全部';
    this.form.source = this.$route.query.source ? this.$route.query.source : '全部';
    this.getSourceList()
  },
  methods: {
    moment,

    onConfirm(date) {
      const [start, end] = date;
      console.log(start, end);
      this.show = false;
      this.time = [start, end]
      this.getListChange()
      this.form.date = `${moment(start).format('MM/DD')} - ${moment(end).format('MM/DD')}`;
    },
    getList() {
      console.log('getList');
      let startTime = '';
      let endTime = '';

      if (this.time.length > 0) {
        startTime = moment(this.time[0]).startOf('day').valueOf();
        endTime = moment(this.time[1]).endOf('day').valueOf();
      } else {
        // 默认显示近7天的数据
        startTime = moment().subtract(7, 'days').startOf('day').valueOf();
        endTime = moment().endOf('day').valueOf();
      }

      let params = {
        characteristic: this.form.attribute == '全部' ? '' : this.form.attribute,
        sort: this.form.sort,
        source: this.form.source == '全部' ? '' : this.form.source,
        startTime,
        endTime,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        topicName: this.$route.query.topicName || '',
        openId: localStorage.getItem('id'),
        search: this.form.search
      }
      warningPage(params).then(res => {
        this.list = this.list.concat(res.dataList.content);
        this.allTotalNumber = res.allTotalNumber
        this.loading = false;
        if (res.dataList.content.length < this.page.pageSize) {
          this.finished = true;
        } else {
          this.page.pageNum++;
        }
      })
    },
    getListChange() {
      this.page.pageNum = 1;
      this.list = [];
      this.getList();
      this.finished = false;
    },
    detail(item) {
      this.$router.push({
        path: '/warn',
        query: {
          item: JSON.stringify(item)
        }
      });
    },
    // 获取来源
    getSourceList() {
      getSource().then(res => {
        res.unshift({ name: '全部' })
        this.option3 = res.map(item => {
          return { text: item.name, value: item.name }
        })
      })
    }
  }
}
</script>
 
<style lang = "less" scoped>
.list {
  list-style: none;
  display: flex;
  width: 100%;
  background: #f6f6f6;

  li {
    display: flex;
    width: 50%;
    height: 48px;
    line-height: 48px;
  }
}

.borFrame {
  padding: .1rem;
}

.borFrame_content {
  /* 文字内容之间的间距 */
  letter-spacing: 1px;
  line-height: 1.5;
  width: 100%;
  margin-top: .1rem;

  &_box {
    width: 100%;
    display: flex;

    &_tag {
      margin-right: .1rem;
      // 边框阴影
      box-shadow: 0 0 0 1px #ccc;
    }

    &_title {
      // 文字溢出显示...
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 80%;
      display: inline-block;
    }
  }

  &_more {
    background: #f8f8f8;
    letter-spacing: 1px;
    line-height: 1.5;
    margin-top: .1rem;
    // 文字超过三行溢出显示...
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  &_btm {
    margin-top: .05rem;
    display: flex;
    flex-wrap: wrap;
  }

  &_sub {
    margin-top: .1rem;
    display: flex;
    justify-content: space-between;

    &_icon {
      width: 50%;
      //文字溢出显示...
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &_time {
      font-size: .12rem;
      margin-top: .05rem;
    }
  }
}

.img {
  vertical-align: middle;
}

/deep/ .van-dropdown-menu__bar {
  box-shadow: none;
  border-radius: 0;
  background: #f6f6f6;
  border: none;
}

/deep/ .van-dropdown-menu__title {
  font-size: .14rem;
}

/deep/.van-search {
  padding: 0;
  background: transparent;
}
</style>